import { render, staticRenderFns } from "./deactivateModal.vue?vue&type=template&id=27434bdc&scoped=true&"
import script from "./deactivateModal.vue?vue&type=script&lang=js&"
export * from "./deactivateModal.vue?vue&type=script&lang=js&"
import style0 from "./deactivateModal.vue?vue&type=style&index=0&id=27434bdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27434bdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27434bdc')) {
      api.createRecord('27434bdc', component.options)
    } else {
      api.reload('27434bdc', component.options)
    }
    module.hot.accept("./deactivateModal.vue?vue&type=template&id=27434bdc&scoped=true&", function () {
      api.rerender('27434bdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DevDashboard/profile/modals/deactivateModal.vue"
export default component.exports